import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import WidthHeight_3275479783, { _demoInfo as WidthHeight_3275479783_demoInfo } from "../../../../../packages/config-common-demo/demo/WidthHeight.tsx?loadDemo";
import PaddingBasic_3275479783, { _demoInfo as PaddingBasic_3275479783_demoInfo } from "../../../../../packages/config-common-demo/demo/PaddingBasic.tsx?loadDemo";
import LegendPosition_3275479783, { _demoInfo as LegendPosition_3275479783_demoInfo } from "../../../../../packages/console-pie-chart/demo/Legend.tsx?loadDemo";
import LegendRight_3275479783, { _demoInfo as LegendRight_3275479783_demoInfo } from "../../../../../packages/console-pie-chart/demo/LegendRight.tsx?loadDemo";
import LegendTip_3275479783, { _demoInfo as LegendTip_3275479783_demoInfo } from "../../../../../packages/console-pie-chart/demo/LegendTip.tsx?loadDemo";
import Tooltip_3275479783, { _demoInfo as Tooltip_3275479783_demoInfo } from "../../../../../packages/console-pie-chart/demo/Tooltip.tsx?loadDemo";
import ComplexTooltip_3275479783, { _demoInfo as ComplexTooltip_3275479783_demoInfo } from "../../../../../packages/console-pie-chart/demo/ComplexTooltip.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  WidthHeight_3275479783,
  WidthHeight_3275479783_demoInfo,
  PaddingBasic_3275479783,
  PaddingBasic_3275479783_demoInfo,
  LegendPosition_3275479783,
  LegendPosition_3275479783_demoInfo,
  LegendRight_3275479783,
  LegendRight_3275479783_demoInfo,
  LegendTip_3275479783,
  LegendTip_3275479783_demoInfo,
  Tooltip_3275479783,
  Tooltip_3275479783_demoInfo,
  ComplexTooltip_3275479783,
  ComplexTooltip_3275479783_demoInfo,
  React
};